<template>
  <div style="font-size: 13px;line-height:30px">
    <el-row :gutter="20">
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span>客户账单编号：<label class="primaryfont">{{ formData.custStatementNo }}</label></span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span>客户名称：{{ formData.custName }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span
          >账单开始-结束日期：{{ formData.beginDate + '~' + formData.endDate }}</span
        >
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span>生成时间：{{ formData.builderTime }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span>应收运费合计：{{ formData.incomeAmount }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span>应收费用合计：{{ formData.incomeCostAmount }}</span>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span>应收合计：{{ formData.incomeTotalAmount }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <span>账单说明：{{ formData.remark }}</span>
      </el-col>
      <el-col :sm="{span: 24}" :md="{span: 8}" :lg="{span: 8}">
        <!-- <el-form-item label="账单状态" prop="custStatementStatus">
          <el-radio-group v-model="formData.custStatementStatus">
            <el-radio label="Y">已收款</el-radio>
            <el-radio label="N">新增</el-radio>
            <el-radio label="P">已开票</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <span
          >账单状态：{{
            formData.custStatementStatus === 'Y'
              ? '已收款'
              : formData.custStatementStatus === 'N'
              ? '新增'
              : formData.custStatementStatus === 'P'
              ? '已开票'
              : ''
          }}</span
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    disabled: Boolean,
    custStatementCode: String,
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {custStatementStatus: 'Y'},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.custStatementCode) return
      this.$api
        .finCustomerStatementDetailApi({
          custStatementCode: this.custStatementCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style scoped>
  .primaryfont {
    color: #007bff
  }
</style>
